module.exports = __webpack_public_path__ + "img/loader.fca663c3.gif";